









































































import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';
import { OverviewLayoutITF, VForm } from '@/interfaces';
import moment from 'moment';

@Component
export default class SiteFilesOverview extends Mixins(OverviewMixin) {
  public tableCfg = FieldDefs;
  public exportMaintenanceDialogValue = false;
  // Set default year to previous year
  public dialogRec = {
    year: moment().subtract(1, 'year').year()
  };
  public exportLoading = false;
  public formValid = false;

  public get theForm() {
    return (this.$refs.form as unknown) as VForm;
  }

  public async exportOverview() {
    const data = {
      filter: this.getFilterValues(),
      sort: this.getSortString()
    };
    this.api.downloadAction(
      this.$store,
      '/sitereportfiles/export_overview/',
      data
    );
  }

  public async exportMaintenanceFiles(year) {
    if (!this.formValid) {
      this.theForm.validate();
    } else {
      this.exportLoading = true;
      const data = {
        year
      };
      await this.api.downloadAction(
        this.$store,
        '/sitereportfiles/export_maintenance/',
        data
      );
      this.exportLoading = false;
      this.exportMaintenanceDialogValue = false;
    }
  }
}
